import { ISharingLoaderReducer } from '../Interfaces/ISharingLoaderReducer';
import { sharingLoaderInitState } from './InitState';
import { IAction } from '../../../../../__core/Interfaces/IAction';
import { IChangeInProgressForStudentModule } from '../Interfaces/IChangeInProgressForStudentModule';
import { accessForModuleInProgressReducer } from './AccessForModuleInProgress';
import { setExamForStudentInProgressReducer } from './SetExamForStudentInProgress';
import { setGrantForAllModulesInProgressReducer } from './SetGrantForAllModulesInProgress';
import { setLecturerGrantForModuleInProgressReducer } from './SetLecturerGrantForModuleInProgress';
import { ISetLecturerGrantForModule } from '../Interfaces/ISetLecturerGrantForModule';
import { shareExamsInProgressReducer } from './ShareExamsInProgress';
import { grantForAllStudentsInProgress } from './GrantForAllStudentsInProgress';
import { IGrantForAllStudentsInProgress } from '../Interfaces/IGrantForAllStudentsInProgress';

export type SharingLoadersAction =
  | IAction<IChangeInProgressForStudentModule>
  | IAction<ISetLecturerGrantForModule>
  | IAction<IGrantForAllStudentsInProgress>
  | IAction<number>;

export const sharingLoadersReducer = (
  state: ISharingLoaderReducer = sharingLoaderInitState,
  action: SharingLoadersAction
): ISharingLoaderReducer => ({
  accessForModuleInProgress: accessForModuleInProgressReducer(
    state.accessForModuleInProgress,
    action as IAction<IChangeInProgressForStudentModule>
  ),
  setExamForStudentInProgress: setExamForStudentInProgressReducer(
    state.setExamForStudentInProgress,
    action as IAction<IChangeInProgressForStudentModule>
  ),
  setGrantForAllModulesInProgress: setGrantForAllModulesInProgressReducer(
    state.setGrantForAllModulesInProgress,
    action as IAction<number>
  ),
  setLecturerGrantForModuleInProgress:
    setLecturerGrantForModuleInProgressReducer(
      state.setLecturerGrantForModuleInProgress,
      action as IAction<ISetLecturerGrantForModule>
    ),
  shareExamsInProgress: shareExamsInProgressReducer(
    state.shareExamsInProgress,
    action as IAction<number>
  ),
  grantForAllStudentsInProgress: grantForAllStudentsInProgress(
    state.grantForAllStudentsInProgress,
    action as IAction<IGrantForAllStudentsInProgress>
  ),
});
